/**
 * @file IconDelete Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-delete',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.75}"
  >
    <path
      fill="#757575"
      fill-rule="nonzero"
      d="M46.5 8.625C47.32843 8.625 48 9.29657 48 10.125 48 10.86138 47.46937 11.47383 46.76963 11.60083L46.5 11.625 42.375 11.625 42.375 40.425C42.375 43.42312 40.06028 45.8806 37.12045 46.10785L36.675 46.125 11.325 46.125C8.32688 46.125 5.8694 43.81028 5.64215 40.87045L5.625 40.425 5.625 11.625 1.5 11.625C.67157 11.625 0 10.95343 0 10.125 0 9.38862.53063 8.77617 1.23037 8.64917L1.5 8.625 46.5 8.625ZM39.375 11.625 8.625 11.625 8.625 40.425C8.625 41.80146 9.65501 42.93736 10.98632 43.10396L11.325 43.125 36.675 43.125C38.05146 43.125 39.18736 42.09499 39.35396 40.76368L39.375 40.425 39.375 11.625ZM33.375 1.125C34.20343 1.125 34.875 1.79657 34.875 2.625 34.875 3.36138 34.34437 3.97383 33.64463 4.10083L33.375 4.125 14.625 4.125C13.79657 4.125 13.125 3.45343 13.125 2.625 13.125 1.88862 13.65563 1.27617 14.35537 1.14917L14.625 1.125 33.375 1.125Z"
    />
    <path
      fill="#757575"
      fill-rule="nonzero"
      d="M18.375 15.75C19.11138 15.75 19.72383 16.28063 19.85083 16.98037L19.875 17.25 19.875 35.25C19.875 36.07843 19.20343 36.75 18.375 36.75 17.63862 36.75 17.02617 36.21937 16.89917 35.51963L16.875 35.25 16.875 17.25C16.875 16.42157 17.54657 15.75 18.375 15.75Z"
    />
    <path
      fill="#757575"
      fill-rule="nonzero"
      d="M29.625 15.75C30.36138 15.75 30.97383 16.28063 31.10083 16.98037L31.125 17.25 31.125 35.25C31.125 36.07843 30.45343 36.75 29.625 36.75 28.88862 36.75 28.27617 36.21937 28.14917 35.51963L28.125 35.25 28.125 17.25C28.125 16.42157 28.79657 15.75 29.625 15.75Z"
    />
  </g>
</svg>
`
);
